import React from 'react'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../../../redux/context/company/selectors'
import FileUpload from '../../../../../components/FileUpload/FileUpload'
import { useIntegrationDocsURL } from '../../../../../utils/docs'

const Efina: React.FC = () => {
  const { t } = useTranslation()
  const integrationDocs = useIntegrationDocsURL()
  const companyId = useSelector(contextCompanyIdSelector)

  return (
    <>
      <a href={integrationDocs.manual('efina')} target="_blank" rel="noopener noreferrer">
        {t('header:manual')}
      </a>
      <FileUpload
        actionUrl={`${process.env.REACT_APP_INTEGRATION_URL}/efina/uploads/${companyId}`}
        taskRequestUrl="/efina/tasks/{companyId}"
        uploadText={t('integrationsPage:csv-info')}
      />
    </>
  )
}

export default Efina
